export default "__VITE_ASSET__90175652__"